<template>
  <div 
    :class="(absolute ? 'absolute top-0 right-0 m-12' : '')+' inline-flex items-center cursor-pointer'"
    @click="$emit('helpClick')"
  >
    <svg
      class="h-6 w-6 text-pink-600"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
    <div class="ml-2 text-base font-normal text-indigo-600">
      Aide
    </div>
  </div>
</template>

<script>
export default {
  props:{
    absolute: {
      type: Boolean,
      required: false,
      default: true
    }
  }
};
</script>